import React from 'react';
import SectionCTA from './SectionCTA';
import { HugeiconsIcon } from '@hugeicons/react';
import { GolfCartIcon, CompassIcon, Flag03Icon } from '@hugeicons/core-free-icons';

const Problem = () => {
  return (
    <section id="learn" className="py-12 sm:py-16 lg:py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Parallax Sand Trap Background */}
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://res.cloudinary.com/dzcrxivpm/image/upload/v1758840676/openart-golf-sand-trap-texture_e4x2Aotv_upscaled_-_01_-_02_zkl5pi.webp"
          alt="Sand trap texture"
          width="1920"
          height="1080"
          className="parallax-bg opacity-50"
          data-speed="0.3"
          loading="lazy"
        />
      </div>
      {/* Lighter Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-white/40 via-transparent to-white/50"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-20">
          <div className="inline-block mb-6">
            <span className="text-red-800 font-bold text-sm uppercase tracking-wider bg-red-50 px-4 py-2 rounded-full">The Hidden Problem</span>
          </div>
          <h2 className="font-playfair font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl text-brand-brown mb-8 leading-tight" style={{ textShadow: '2px 2px 8px rgba(26, 77, 31, 0.3)' }}>
            The $5,200 Mistake<br/>
            <span className="text-brand-green font-bold">90% of Golfers Make Every Year</span>
          </h2>
          <p className="text-xl text-gray-900 max-w-4xl mx-auto leading-relaxed">
            You take lessons religiously. You practice twice a week.<br/>You can stripe it on the range.
            <strong> But your scores stay the same.</strong>
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-16">
          <div className="text-center rounded-3xl p-8 relative overflow-hidden glass-card" style={{
            background: 'rgba(84, 84, 84, 0.08)',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
            boxShadow: 'inset 0 0 0 1px rgba(255, 255, 255, 0.5), inset 0 0 0 2px rgba(255, 255, 255, 0.2), 0 4px 24px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.08)'
          }}>
            {/* Liquid glass effect overlay */}
            <div className="absolute inset-0 opacity-30 pointer-events-none" style={{ background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 40%, transparent 60%, rgba(255,255,255,0.05) 100%)' }}></div>
            <div className="w-24 h-24 bg-gradient-to-br from-green-500 to-green-700 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-modern relative z-10">
              <HugeiconsIcon icon={GolfCartIcon} size={48} color="white" />
            </div>
            <h3 className="font-inter font-bold text-2xl mb-4 text-brand-brown relative z-10">Expensive Lessons Don't Transfer</h3>
            <p className="text-gray-700 leading-relaxed text-lg relative z-10">
              Golf instruction focuses on the 4 seconds you're swinging the club.
              But golf is really about the 4 minutes between shots when you're making decisions.
            </p>
          </div>

          <div className="text-center rounded-3xl p-8 relative overflow-hidden glass-card" style={{
            background: 'rgba(84, 84, 84, 0.08)',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
            boxShadow: 'inset 0 0 0 1px rgba(255, 255, 255, 0.5), inset 0 0 0 2px rgba(255, 255, 255, 0.2), 0 4px 24px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.08)'
          }}>
            {/* Liquid glass effect overlay */}
            <div className="absolute inset-0 opacity-30 pointer-events-none" style={{ background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 40%, transparent 60%, rgba(255,255,255,0.05) 100%)' }}></div>
            <div className="w-24 h-24 bg-gradient-to-br from-green-500 to-green-700 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-modern relative z-10">
              <HugeiconsIcon icon={CompassIcon} size={48} color="white" />
            </div>
            <h3 className="font-inter font-bold text-2xl mb-4 text-brand-brown relative z-10">You're Flying Blind<br/>Out There</h3>
            <p className="text-gray-700 leading-relaxed text-lg relative z-10">
              Most golfers use "best case" distances and aim at flags without strategy.
              You're bleeding 5-7 strokes per round on simple decisions.
            </p>
          </div>

          <div className="text-center rounded-3xl p-8 relative overflow-hidden glass-card" style={{
            background: 'rgba(84, 84, 84, 0.08)',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
            boxShadow: 'inset 0 0 0 1px rgba(255, 255, 255, 0.5), inset 0 0 0 2px rgba(255, 255, 255, 0.2), 0 4px 24px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.08)'
          }}>
            {/* Liquid glass effect overlay */}
            <div className="absolute inset-0 opacity-30 pointer-events-none" style={{ background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 40%, transparent 60%, rgba(255,255,255,0.05) 100%)' }}></div>
            <div className="w-24 h-24 bg-gradient-to-br from-green-500 to-green-700 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-modern relative z-10">
              <HugeiconsIcon icon={Flag03Icon} size={48} color="white" />
            </div>
            <h3 className="font-inter font-bold text-2xl mb-4 text-brand-brown relative z-10">Stuck at the Same<br/>Handicap</h3>
            <p className="text-gray-700 leading-relaxed text-lg relative z-10">
              You're trying to perfect your swing instead of perfecting your strategy.
              Playing golf like it's a driving range instead of chess.
            </p>
          </div>
        </div>

        {/* Desktop CTA */}
        <SectionCTA className="mt-12" />
      </div>
    </section>
  );
};

export default Problem;